import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Args = {
  content: CmsApiPage;
};

export function getCmsContentPadBottom({ content }: Args) {
  const lastBlock = content.contentBlocks[content.contentBlocks.length - 1];

  return (
    lastBlock &&
    !['CTA_HERO', 'GRAD_CTA_HERO', 'SPLIT_CONTENT'].includes(lastBlock.type)
  );
}
